import { defineComponent } from "@vue/composition-api";
import { useI18n } from "vue-i18n-composable";
import ScrollableContainer from "@Shared/components/general/scrollable-container.vue";
export default defineComponent({
  name: "ReportsTabs",
  components: {
    ScrollableContainer
  },
  setup() {
    const {
      t
    } = useI18n();
    const pages = [{
      route: {
        name: "application-summary-report"
      },
      label: t("application-reports.applications-summary.name")
    }, {
      route: {
        name: "firm-statistics-report"
      },
      label: t("application-reports.firm-statistics.name")
    }, {
      route: {
        name: "renewal-tracking-report"
      },
      label: t("application-reports.renewal-tracking.name")
    }, {
      route: {
        name: "lender-transactions-report"
      },
      label: t("application-reports.lender-transactions.name")
    }, {
      route: {
        name: "commissions-report"
      },
      label: t("application-reports.commissions.name")
    }, {
      route: {
        name: "risk-level-report"
      },
      label: t("application-reports.risk-level.name")
    }, {
      route: {
        name: "history-report"
      },
      label: t("application-reports.history.name")
    }];
    return {
      pages
    };
  }
});